import { LocalityModel } from "@/types/LocalityModel";
import { LocaliteCard } from "./LocaliteCard";

export default function SearchResult({
  localites,
}: {
  localites: LocalityModel[];
}) {
  return (
    <div className="grid h-full grid-cols-1 gap-1 sm:grid-cols-3">
      {localites.map((localite, index) => (
        <LocaliteCard key={index} localite={localite} />
      ))}
    </div>
  );
}
